import type { ReactNode } from 'react';

/**
 * Title, subtitle and a primary action.
 *
 * Shared so every page's heading sits at the same size and baseline — the
 * cheapest way to stop a multi-screen admin feeling like several apps stitched
 * together.
 */
export const PageHeader = ({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}): React.JSX.Element => (
  <div className="flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
      {subtitle && <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {action}
  </div>
);
